module.exports = __webpack_public_path__ + "static/media/SlideArrowRight.09f36782.svg";